import { apiRequest } from "./apiClient";

export type DashboardStatsParams = {
  date?: string;
};

export type DashboardChartsParams = {
  date?: string;
  range?: "7d" | "3m" | "6m" | string;
  groupBy?: "day" | "month";
};

export type DashboardStat = {
  id: string;
  label: string;
  value: number;
  unit?: string;
};

export type DashboardChartPoint = {
  label: string;
  value: number;
};

export type DashboardChart = {
  unit?: string;
  series: DashboardChartPoint[];
};

export type DashboardStatsResponse = {
  stats: DashboardStat[];
  generatedAt: string;
};

export type DashboardChartsResponse = {
  charts: {
    newCards?: DashboardChart;
    waterDispense?: DashboardChart;
    rechargeAmount?: DashboardChart;
    [key: string]: DashboardChart | undefined;
  };
  meta: {
    generatedAt: string;
    referenceDate: string;
    range: string;
    groupBy: "day" | "month";
  };
};

export async function fetchDashboardStats(
  params: DashboardStatsParams = {},
  signal?: AbortSignal
) {
  const searchParams = new URLSearchParams();
  if (params.date) {
    searchParams.set("date", params.date);
  }

  const endpoint = searchParams.toString()
    ? `/api/dashboard/stats?${searchParams.toString()}`
    : "/api/dashboard/stats";

  return apiRequest<DashboardStatsResponse>(endpoint, {
    method: "GET",
    signal,
  });
}

export async function fetchDashboardCharts(
  params: DashboardChartsParams = {},
  signal?: AbortSignal
) {
  const searchParams = new URLSearchParams();
  if (params.date) {
    searchParams.set("date", params.date);
  }
  if (params.range) {
    searchParams.set("range", params.range);
  }
  if (params.groupBy) {
    searchParams.set("groupBy", params.groupBy);
  }

  const endpoint = searchParams.toString()
    ? `/api/dashboard/charts?${searchParams.toString()}`
    : "/api/dashboard/charts";

  return apiRequest<DashboardChartsResponse>(endpoint, {
    method: "GET",
    signal,
  });
}
